import { render, staticRenderFns } from "./ttshop_darterttdelivery.vue?vue&type=template&id=14253963&scoped=true&"
import script from "./ttshop_darterttdelivery.vue?vue&type=script&lang=js&"
export * from "./ttshop_darterttdelivery.vue?vue&type=script&lang=js&"
import style0 from "./ttshop_darterttdelivery.vue?vue&type=style&index=0&id=14253963&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14253963",
  null
  
)

export default component.exports